import React from 'react';
import { ArrowLeft } from 'lucide-react';

export const PageHeader = ({
  title,
  subtitle,
  onBack,
  showBack = true,
  rightAction = null,
  leftAction = null,
  centerTitle = false,
}) => {
  const hasHeaderContent = Boolean(showBack || leftAction || rightAction || subtitle);

  if (!hasHeaderContent) {
    return null;
  }

  return (
    <div className="mb-3 sm:mb-5">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-start gap-2 sm:gap-3 min-w-0 flex-1">
          {leftAction && <div className="shrink-0">{leftAction}</div>}
          {showBack && (
            <button
              onClick={onBack}
              style={{ minWidth: '44px', minHeight: '44px' }}
              className="rounded-xl border border-slate-200 bg-white text-slate-700 flex items-center justify-center mt-0.5 hover:bg-slate-50 transition-colors shrink-0"
              aria-label="Go back"
            >
              <ArrowLeft size={18} />
            </button>
          )}
          <div className="pt-0.5 min-w-0 flex-1">
            {subtitle && <p className="text-slate-500 text-xs sm:text-sm truncate-2-lines">{subtitle}</p>}
          </div>
        </div>
        {rightAction && (
          <div className="w-full sm:w-auto flex flex-wrap items-center justify-start sm:justify-end gap-2 shrink-0">
            {rightAction}
          </div>
        )}
      </div>
    </div>
  );
};
